export default "__VITE_ASSET__EjI2kBjj__"